import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import timetracking from './modules/timetracking';
import projects from './modules/projects';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    timetracking,
    projects,
  },
});
